module.exports = __webpack_public_path__ + "static/media/3DPPA19.b1431cf3.jpg";